import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useLogin } from '../context/LoginContext'
import { useModalities } from '../context/ModalitiesContext'

import TitleBox from '../components/common/TitleBox'
import Button from '../components/common/Button'
import ContainerBox from '../components/common/ContainerBox'
import Modal from '../components/common/Modal'
import TableData from '../components/common/TableData'
import { IconEdit, IconPlus, IconTrash } from '../components/icons/Icons'
import ModalitiesForm from '../components/forms/ModalitiesForm'

const ModalidadesPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [idData, setIdData] = useState(null);
  const navigate = useNavigate()
  const { user } = useLogin();
  const { getModalities, modalities, modal, getModal } = useModalities();

  useEffect(() => {
    if (user !== null) {
      navigate('/modalidades')
    }
    getModalities()
  }, [user])

  const columns = [
    {
      header: '#',
      cell: ({ cell }) => {
        const { row } = cell;
        return <div>{row.index + 1}</div>
      }
    },
    {
      header: 'Descripción',
      accessorKey: 'name'
    },
    {
      header: 'Acciones',
      cell: ({ cell }) => {
        const id = cell.row.original.id
        return <div className='flex items-center'>
          <button
            className="bg-warning/80 hover:bg-warning border border-warning/80 text-xs text-black/50 px-2 py-1 rounded-sm"
            title='Editar'
            onClick={() => openModal(id)}
          >
            <IconEdit className='w-4' />
          </button>
          <button
            className="bg-danger/90 hover:bg-danger border border-danger/90 text-xs text-white px-2 py-1 rounded-sm"
            title='Eliminar'
            onClick={openModal}
          >
            <IconTrash className='w-4' />
          </button>
        </div>
      }
    }
  ]

  const openModal = (id = null) => {
    setIsModalOpen(true);
    setIdData(id)
    getModal()
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <TitleBox title='Relación de modalidades' />
      <ContainerBox>
        <Button value='Nuevo' openModal={() => openModal()}>
          <IconPlus className='w-4' />
        </Button>
        <TableData columns={columns} data={modalities} />
      </ContainerBox>
      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        isModal={modal}
        title={"Nuevo registro"}
        modalSize='sm'
      >
        <ModalitiesForm idData={idData} />
      </Modal>
    </>
  )
}

export default ModalidadesPage